export const LOGO_URL = "https://customer-assets.emergentagent.com/job_d699de34-090c-426b-bc64-be41a62a6307/artifacts/h08ee32k_a_logo_for_skymoon_consultancy_is_displayed_on_a_t.png";

export const content = {
  fr: {
    nav: {
      vision: "Vision",
      pillars: "Nos Piliers",
      action: "Champ d'Action",
      civentia: "Civentia",
      founders: "Fondateurs",
      partners: "Partenaires",
      contact: "Contact"
    },
    hero: {
      title: "Architectes de la Souveraineté Productive",
      subtitle: "Structuration • Investissement • Développement",
      description: "Holding opérationnelle de structuration, d'investissement, de partenariats et de développement de projets stratégiques au service de la souveraineté économique africaine.",
      cta: "Découvrir Nos Piliers",
      ctaSecondary: "Devenir Partenaire",
      locations: "Dubai • Dakar"
    },
    vision: {
      label: "Notre Vision",
      title: "Construire la Souveraineté Économique",
      text: "Skymoon est une holding opérationnelle qui initie, structure et développe des projets stratégiques au service de la souveraineté productive africaine. Depuis Dakar, nous connectons investisseurs, gouvernements et partenaires technologiques pour bâtir des écosystèmes économiques durables et réduire la dépendance aux importations.",
      stats: [
        { value: "3", label: "Piliers d'Activité" },
        { value: "Dakar", label: "Siège Social" },
        { value: "Multi", label: "Secteurs" }
      ]
    },
    pillars: {
      label: "Nos Piliers",
      title: "Trois Axes Stratégiques",
      items: [
        {
          number: "01",
          title: "Structuration & Business Development",
          desc: "Représentation stratégique exclusive auprès d'investisseurs, gouvernements et institutions. Structuration de partenariats complexes, négociations à fort enjeu, liaison réglementaire et développement d'opportunités institutionnelles et commerciales."
        },
        {
          number: "02",
          title: "Participations & Joint-Ventures",
          desc: "Prise de participation majoritaire dans des véhicules opérationnels spécialisés. Création et contrôle de joint-ventures stratégiques via nos entités comme Civentia, avec ouverture aux investisseurs minoritaires pour les projets industriels."
        },
        {
          number: "03",
          title: "Déploiement Sectoriel & Industriel",
          desc: "Développement agro-industriel, intégration technologique, chaînes d'approvisionnement et création d'unités locales de production pour renforcer la souveraineté productive et réduire les importations."
        }
      ]
    },
    actionFields: {
      label: "Champ d'Action",
      title: "Nos Domaines d'Intervention",
      items: [
        { icon: "Handshake", title: "Structuration de Projets & Partenariats", desc: "Montage, préparation et structuration de dossiers complexes. Développement d'opportunités institutionnelles et commerciales." },
        { icon: "Users", title: "Accompagnement d'Investisseurs", desc: "Conseil, représentation et intermédiation pour investisseurs institutionnels et privés souhaitant accéder aux marchés africains." },
        { icon: "Target", title: "Représentation Stratégique", desc: "Interface exclusive entre partenaires technologiques, gouvernements et institutions pour les négociations structurantes." },
        { icon: "Building2", title: "Participations dans Véhicules Spécialisés", desc: "Contrôle majoritaire de véhicules opérationnels comme Civentia pour l'exécution de projets stratégiques." },
        { icon: "Sprout", title: "Développement Agro-Industriel", desc: "Ingénierie agricole, intégration de technologies innovantes et projets pilotes pour l'agriculture durable." },
        { icon: "Truck", title: "Chaînes d'Approvisionnement & Distribution", desc: "Structuration et optimisation des flux logistiques, schémas de distribution nationaux." },
        { icon: "Factory", title: "Souveraineté Productive", desc: "Création d'unités locales de production pour réduire les importations et renforcer l'autonomie économique." },
        { icon: "Landmark", title: "Relations Institutionnelles", desc: "Liaison réglementaire avec ministères et institutions publiques. Programmes publics et pilotes institutionnels." }
      ]
    },
    civentia: {
      label: "Véhicule Opérationnel",
      title: "CIVENTIA",
      subtitle: "Le Bras Opérationnel de Skymoon",
      desc: "Civentia est notre véhicule dédié à l'exécution opérationnelle des projets industriels et agricoles. Cette structure agile porte les activités d'ingénierie territoriale et agricole, d'intégration technologique, de projets pilotes et de déploiements locaux au service de la souveraineté économique et productive nationale.",
      features: [
        "Ingénierie territoriale et agricole",
        "Intégration de technologies innovantes",
        "Exécution de projets pilotes et études",
        "Création d'unités locales de production",
        "Structuration de partenariats opérationnels"
      ]
    },
    founders: {
      label: "Leadership",
      title: "Nos Fondateurs",
      subtitle: "Deux frères sénégalais unis par une vision commune : renforcer la souveraineté économique et productive de l'Afrique à travers des partenariats stratégiques et des projets industriels durables.",
      team: [
        {
          name: "Abou DAFFE",
          role: "Associé Fondateur",
          specialty: "Stratégie & Partenariats",
          bio: "Doté d'un réseau relationnel exceptionnel à l'international, Abou excelle dans la mise en relation stratégique entre investisseurs, partenaires technologiques et institutions gouvernementales. Son talent pour créer des connexions de haut niveau et sa capacité à ouvrir des portes font de lui le pilier des partenariats de Skymoon.",
          email: "abou.daffe@skymoonconsultancy.com"
        },
        {
          name: "Abidine DAFFE",
          role: "Associé Fondateur",
          specialty: "Opérations & Industrie",
          bio: "Fort de 15 ans d'expérience en Europe dans le secteur industriel et alimentaire, Abidine supervise le déploiement opérationnel des projets, l'intégration technologique et la création d'unités de production locales. Expert en gestion de centres de profits et transmission de savoir-faire.",
          email: "abidine.daffe@skymoonconsultancy.com"
        }
      ]
    },
    partners: {
      label: "Écosystème",
      title: "Nos Partenaires",
      subtitle: "Des collaborations stratégiques exclusives pour un impact durable sur la souveraineté productive.",
      items: [
        {
          name: "ANT Systems",
          type: "Partenaire Technologique",
          desc: "ANT Systems Nano Teknoloji (Turquie) est notre partenaire technologique pour le déploiement de la solution Nanotern au Sénégal. Cette technologie de nanotechnologie permet une rétention d'eau optimale et une réduction significative de la consommation d'eau agricole.",
          url: "https://www.ant-systems.com/"
        },
        {
          name: "Doktar",
          type: "Partenaire IoT & Data",
          desc: "Doktar (Turquie) déploie des capteurs intelligents Filiz pour la collecte de données directement sur le sol : température, humidité, détection de maladies et recommandations d'irrigation. Une agriculture de précision au service de la souveraineté alimentaire.",
          url: "https://www.doktar.com/"
        }
      ],
      project: {
        title: "Résilience Hydrique Sénégal 2035",
        status: "Programme Phare — Partenariat Stratégique",
        desc: "Programme national de résilience hydrique et d'industrialisation des sols agricoles, initié et structuré par Skymoon Consultancy et Civentia. Ce projet d'envergure vise la création au Sénégal d'une plateforme industrielle de production, de formulation et de diffusion de solutions de rétention d'eau, avec l'ambition de faire du pays le premier hub africain des technologies de résilience hydrique.",
        desc2: "Skymoon assure l'initiation du programme, la mobilisation des partenaires internationaux, la structuration des financements et l'accès aux marchés régionaux. Civentia porte l'ancrage national, l'innovation et le contenu local, en lien avec les institutions, la recherche et les producteurs.",
        pillars: [
          { title: "Plateforme Industrielle", desc: "Production, formulation et conditionnement locaux de solutions de rétention d'eau, adossés à une plateforme logistique nationale et régionale." },
          { title: "Souveraineté Agricole", desc: "Valorisation de chaque litre d'eau, sécurisation des rendements et réduction de la vulnérabilité climatique des sols sahéliens." },
          { title: "R&D & Formation", desc: "Laboratoire de contrôle, centre de recherche agronomique et montée en compétences locales pour créer des référentiels africains." },
          { title: "Rayonnement Régional", desc: "Approvisionnement de l'Afrique de l'Ouest et exportation de solutions adaptées aux réalités sahéliennes, créatrices d'emplois et de valeur ajoutée." }
        ],
        vision: "Vision 2035 : transformer une vulnérabilité structurelle en opportunité industrielle, agricole et régionale."
      }
    },
    contact: {
      label: "Contact",
      title: "Construisons Ensemble",
      subtitle: "Investisseurs, partenaires technologiques, institutions : explorons les opportunités de collaboration.",
      headquarters: [
        { city: "Dubai", address: "Émirats Arabes Unis" },
        { city: "Dakar", address: "Sénégal" }
      ],
      email: "contact@skymoonconsultancy.com",
      fields: {
        name: "Nom Complet",
        email: "Adresse Email",
        org: "Organisation",
        message: "Message",
        submit: "Envoyer",
        sending: "Envoi en cours...",
        success: "Message envoyé avec succès. Nous vous répondrons rapidement.",
        error: "Une erreur est survenue. Veuillez réessayer ou nous écrire directement par email."
      },
      domains: ["Structuration de Projets", "Investissement", "Agro-Industrie", "Partenariat Technologique", "Commerce International"]
    },
    footer: {
      rights: "Tous droits réservés",
      tagline: "Holding Opérationnelle de Structuration, d'Investissement et de Développement",
      trade: "Commerce International"
    }
  },
  en: {
    nav: {
      vision: "Vision",
      pillars: "Our Pillars",
      action: "Action Fields",
      civentia: "Civentia",
      founders: "Founders",
      partners: "Partners",
      contact: "Contact"
    },
    hero: {
      title: "Architects of Productive Sovereignty",
      subtitle: "Structuring • Investment • Development",
      description: "Operational holding for structuring, investment, partnerships and strategic project development serving African economic sovereignty.",
      cta: "Discover Our Pillars",
      ctaSecondary: "Become a Partner",
      locations: "Dubai • Dakar"
    },
    vision: {
      label: "Our Vision",
      title: "Building Economic Sovereignty",
      text: "Skymoon is an operational holding that initiates, structures and develops strategic projects serving African productive sovereignty. From Dakar, we connect investors, governments and technology partners to build sustainable economic ecosystems and reduce import dependency.",
      stats: [
        { value: "3", label: "Activity Pillars" },
        { value: "Dakar", label: "Headquarters" },
        { value: "Multi", label: "Sectors" }
      ]
    },
    pillars: {
      label: "Our Pillars",
      title: "Three Strategic Axes",
      items: [
        {
          number: "01",
          title: "Structuring & Business Development",
          desc: "Exclusive strategic representation with investors, governments and institutions. Structuring complex partnerships, high-stakes negotiations, regulatory liaison and development of institutional and commercial opportunities."
        },
        {
          number: "02",
          title: "Participations & Joint-Ventures",
          desc: "Majority stake in specialized operational vehicles. Creation and control of strategic joint ventures through entities like Civentia, with opening to minority investors for industrial projects."
        },
        {
          number: "03",
          title: "Sectoral & Industrial Deployment",
          desc: "Agro-industrial development, technology integration, supply chains and creation of local production units to strengthen productive sovereignty and reduce imports."
        }
      ]
    },
    actionFields: {
      label: "Action Fields",
      title: "Our Areas of Intervention",
      items: [
        { icon: "Handshake", title: "Project & Partnership Structuring", desc: "Setup, preparation and structuring of complex files. Development of institutional and commercial opportunities." },
        { icon: "Users", title: "Investor Support", desc: "Advisory, representation and intermediation for institutional and private investors seeking access to African markets." },
        { icon: "Target", title: "Strategic Representation", desc: "Exclusive interface between technology partners, governments and institutions for structural negotiations." },
        { icon: "Building2", title: "Specialized Vehicle Participations", desc: "Majority control of operational vehicles like Civentia for strategic project execution." },
        { icon: "Sprout", title: "Agro-Industrial Development", desc: "Agricultural engineering, innovative technology integration and pilot projects for sustainable agriculture." },
        { icon: "Truck", title: "Supply Chains & Distribution", desc: "Structuring and optimization of logistics flows, national distribution schemes." },
        { icon: "Factory", title: "Productive Sovereignty", desc: "Creation of local production units to reduce imports and strengthen economic autonomy." },
        { icon: "Landmark", title: "Institutional Relations", desc: "Regulatory liaison with ministries and public institutions. Public programs and institutional pilots." }
      ]
    },
    civentia: {
      label: "Operational Vehicle",
      title: "CIVENTIA",
      subtitle: "Skymoon's Operational Arm",
      desc: "Civentia is our vehicle dedicated to operational execution of industrial and agricultural projects. This agile structure carries territorial and agricultural engineering activities, technology integration, pilot projects and local deployments serving national economic and productive sovereignty.",
      features: [
        "Territorial and agricultural engineering",
        "Innovative technology integration",
        "Pilot project and study execution",
        "Local production unit creation",
        "Operational partnership structuring"
      ]
    },
    founders: {
      label: "Leadership",
      title: "Our Founders",
      subtitle: "Two Senegalese brothers united by a common vision: strengthening Africa's economic and productive sovereignty through strategic partnerships and sustainable industrial projects.",
      team: [
        {
          name: "Abou DAFFE",
          role: "Founding Partner",
          specialty: "Strategy & Partnerships",
          bio: "With an exceptional international network, Abou excels at strategic connections between investors, technology partners and government institutions. His talent for creating high-level connections and his ability to open doors make him the cornerstone of Skymoon's partnerships.",
          email: "abou.daffe@skymoonconsultancy.com"
        },
        {
          name: "Abidine DAFFE",
          role: "Founding Partner",
          specialty: "Operations & Industry",
          bio: "With 15 years of experience in Europe in industrial and food sectors, Abidine oversees operational project deployment, technology integration and local production unit creation. Expert in profit center management and knowledge transfer.",
          email: "abidine.daffe@skymoonconsultancy.com"
        }
      ]
    },
    partners: {
      label: "Ecosystem",
      title: "Our Partners",
      subtitle: "Exclusive strategic collaborations for lasting impact on productive sovereignty.",
      items: [
        {
          name: "ANT Systems",
          type: "Technology Partner",
          desc: "ANT Systems Nano Teknoloji (Turkey) is our technology partner for deploying the Nanotern solution in Senegal. This nanotechnology enables optimal water retention and significant reduction in agricultural water consumption.",
          url: "https://www.ant-systems.com/"
        },
        {
          name: "Doktar",
          type: "IoT & Data Partner",
          desc: "Doktar (Turkey) deploys Filiz smart sensors for direct soil data collection: temperature, humidity, disease detection and irrigation recommendations. Precision agriculture serving food sovereignty.",
          url: "https://www.doktar.com/"
        }
      ],
      project: {
        title: "Senegal Water Resilience 2035",
        status: "Flagship Program — Strategic Partnership",
        desc: "National program for water resilience and agricultural soil industrialization, initiated and structured by Skymoon Consultancy and Civentia. This large-scale project aims to create in Senegal an industrial platform for the production, formulation and distribution of water retention solutions, with the ambition of making the country the first African hub for water resilience technologies.",
        desc2: "Skymoon leads program initiation, international partner mobilization, financing structuring and access to regional markets. Civentia carries national anchoring, innovation and local content, working with institutions, research and producers.",
        pillars: [
          { title: "Industrial Platform", desc: "Local production, formulation and packaging of water retention solutions, backed by a national and regional logistics platform." },
          { title: "Agricultural Sovereignty", desc: "Making every liter of water count, securing yields and reducing the climate vulnerability of Sahelian soils." },
          { title: "R&D & Training", desc: "Quality control laboratory, agronomic research center and local skills development to create African standards." },
          { title: "Regional Reach", desc: "Supplying West Africa and exporting solutions adapted to Sahelian realities, generating jobs and added value." }
        ],
        vision: "Vision 2035: transforming a structural vulnerability into an industrial, agricultural and regional opportunity."
      }
    },
    contact: {
      label: "Contact",
      title: "Let's Build Together",
      subtitle: "Investors, technology partners, institutions: let's explore collaboration opportunities.",
      headquarters: [
        { city: "Dubai", address: "United Arab Emirates" },
        { city: "Dakar", address: "Senegal" }
      ],
      email: "contact@skymoonconsultancy.com",
      fields: {
        name: "Full Name",
        email: "Email Address",
        org: "Organization",
        message: "Message",
        submit: "Send",
        sending: "Sending...",
        success: "Message sent successfully. We will get back to you shortly.",
        error: "An error occurred. Please try again or email us directly."
      },
      domains: ["Project Structuring", "Investment", "Agro-Industry", "Technology Partnership", "International Trade"]
    },
    footer: {
      rights: "All rights reserved",
      tagline: "Operational Holding for Structuring, Investment and Development",
      trade: "International Trade"
    }
  }
};
